var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"video-container",attrs:{"id":"player-container"}}),(_vm.isLoading)?_c('img',{staticClass:"play-loading",attrs:{"src":require("../../assets/images/loading.png")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }